import moment from "moment";
export const thaiText = /^[\u0E01-\u0E3A\u0E40-\u0E4D\s]*$/i;
export const engText = /^[a-zA-Z.-]*$/i;
export const taxNumberRex = /^[0-9a-zA-Z.-\s/]*$/i;
export function checkIdcard(a) {
  if (!a) {
    return false;
  }
  var chk_a = a.length !== 13 ? false : true;
  if (chk_a) {
    var id = a;
    var sum, i;
    for (i = 0, sum = 0; i < 12; i++)
      sum += parseFloat(id.charAt(i)) * (13 - i);
    if ((11 - (sum % 11)) % 10 !== parseFloat(id.charAt(12)))
      return (chk_a = false);
    return (chk_a = true);
  } else {
    return chk_a;
  }
}
export function formatterIdCard(input) {
  if (!input || input.length !== 13) return input;
  else {
    return input.replace(
      /(\d{1})(\d{4})(\d{5})(\d{2})(\d{1})/,
      "$1-$2-$3-$4-$5"
    );
  }
}
export function formatterBackIdCard(input) {
  if (!input || input.length !== 12) return input;
  else {
    let d = input.split("");
    let resetFormat = "";
    d.forEach((row, i) => {
      if (i === 3 || i === 10) resetFormat += "-";
      resetFormat += row;
    });
    return resetFormat;
  }
}
export function mailFormat(input) {
  return input.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/);
}
export function formatterDate(input) {
  if (!input) return input;
  return moment(input).format("YYYY/MM/DD");
}

export function fomatterTH(input) {
  return input.replace(
    /[^กขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรฤลฦวศษสหฬอฮฯะัาำิีึืฺุูเแโใไๅๆ็่้๊๋์.\s\-]/g,
    ""
  );
}
export function fomatterEN(input) {
  return input.replace(/[^a-zA-Z.\s\-]/g, "");
}
export function fomatterNumber(input) {
  return input.replace(/[^0-9]/g, "");
}
export function fomaterBankNumber(input) {
  if (!input || input.length !== 10) return input;
  else return input.replace(/(\d{3})(\d{1})(\d{5})(\d{1})/, "$1-$2-$3-$4");
}
export function houseNoFormat(input) {
  return input.match(/^[a-zA-Z0-9-\u0E01-\u0E5B/]+$/);
}
export function mooFormat(input) {
  return input.match(/^[0-9--]+$/);
}
export function currencyFormat(input) {
  if (input.length > 3) {
    return input.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
  } else {
    return input;
  }
}
export const thaiStringFormat = (value) => {
  if (value) {
    return thaiText.test(value);
  }
  if (!value) {
    return true;
  }

  return false;
};
export const englishStringFormat = (value) => {
  if (value) {
    return engText.test(value);
  }
  if (!value) {
    return true;
  }

  return false;
};

export const taxNumberValidate = (value) => {
  if (value) {
    return taxNumberRex.test(value);
  }
  if (!value) {
    return true;
  }

  return false;
};
